import quote from "./images/quote.png";
import logo from "./images/logo.svg";
import loginBg from "./images/login_bg.png";
import whiteLogo from "./images/white_logo.svg";
import dashboard from "./icons/dashboard.svg";
import taskboard from "./icons/taskboard.svg";
import calendar from "./icons/calendar.svg";
import checklist_PosterImage from "./icons/checklist_PosterImage.png";
import handshake_PosterImage from "./icons/handshake_PosterImage.png";
import socialmedia_PosterImage from "./icons/socialmedia_PosterImage.png";
import calendar_PosterImage from "./icons/calendar_PosterImage.png";
import taskCompleted from "./icons/taskCompleted.svg";
import totalClients from "./icons/totalClients.svg";
import taskInprogress from "./icons/taskInprogress.svg";
import taskTodo from "./icons/taskTodo.svg";
import taskUnderReview from "./icons/taskUnderReview.svg";
import totalTasks from "./icons/totalTasks.svg";
import invoicing from "./icons/invoicing.svg";
import clients from "./icons/clients.svg";
import storage from "./icons/storage.svg";
import team from "./icons/team.svg";
import reports from "./icons/reports.svg";
import settings from "./icons/settings.svg";
import broadcast from "./icons/broadcast.svg";
import logout from "./icons/logout.svg";
import man from "./icons/man.svg";
import profile from "./icons/profile.svg";
import date from "./icons/calendar.png";
import shuffle from "./icons/shuffle.svg";
import formIcon from "./icons/formIcon.svg";
import empty from "./images/empty.svg";
import user from "./icons/user.png";
import folder from "./icons/folder.png";
import pdf from "./icons/filetypes/pdf.png";
import doc from "./icons/filetypes/docs.png";
import excel from "./icons/filetypes/excel.png";
import csv from "./icons/filetypes/csv.png";
import text from "./icons/filetypes/text.png";
import ppt from "./icons/filetypes/ppt.png";
import zip from "./icons/filetypes/zip.png";
import video from "./icons/filetypes/video.png";
import audio from "./icons/filetypes/audio.png";
import recurring from "./icons/recurring.svg";
import singleLine from "./icons/singleLine.svg";
import email from "./icons/email.svg";
import address from "./icons/address.svg";
import multiLine from "./icons/multiLine.svg";
import name from "./icons/name.svg";
import checkBox from "./icons/checkBox.svg";
import fileUpload from "./icons/fileUpload.svg";
import imageUpload from "./icons/imageUpload.svg";
import termsAndConditions from "./icons/termsAndConditions.svg";
import currency from "./icons/currency.svg";
import signature from "./icons/signature.svg";
import dropDown from "./icons/dropDown.svg";
import decisionBox from "./icons/decisionBox.svg";
import fieldDate from "./icons/date.svg";
import mobileNumber from "./icons/mobileNumber.svg";
import numbers from "./icons/number.svg";
import profileImage from "./images/profile.jpg";
import noAttachments from "./images/no_attachments.svg";
import noSubTasks from "./images/noSubTasks.svg";
import noChecklists from "./images/noChecklists.svg";
import noMilestones from "./images/noMilestones.svg";
import noDueDiligence from "./images/noDueDiligence.svg";
import noEvents from "./images/noEvents.svg";
import signup from "./images/signup.png";
import newlogo from "./images/newlogo.png";
import emptyLicenses from "./images/emptyLicenses.png";
import createFormLanding from "./images/createFormLanding.png";
import clientFormCard from "./images/clientFormCard.png";
import file from "./icons/file.png";
import atom_logo from "./images/atom_logo.png";
import atom_logo_no_background from "./images/atom_logo_no_background.jpeg";
import Quantum from "./images/Quantum.png";
import documents from "./images/documents.png";
import vider_logo_white from "./images/vider_logo_white.jpeg";
import serviceopg1 from "./images/serviceopg1.jpg";
import prismLogo from "./images/PrismLogo.png";
import vider_logo from './images/vider_logo.png';
import completed from './images/completed.png';
import pendingImg from './images/pending.png';

export {
  quote,
  logo,
  loginBg,
  whiteLogo,
  empty,
  profileImage,
  noAttachments,
  noSubTasks,
  noChecklists,
  noMilestones,
  noDueDiligence,
  noEvents,
  signup,
  newlogo,
  emptyLicenses,
  createFormLanding,
  clientFormCard,
  atom_logo,
  atom_logo_no_background,
  Quantum,
  documents,
  serviceopg1,
  vider_logo_white,
  prismLogo,
  vider_logo,
  completed,
  pendingImg
};

export const icons = {
  totalTasks,
  totalClients,
  taskCompleted,
  taskInprogress,
  taskTodo,
  taskUnderReview,
  checklist_PosterImage,
  handshake_PosterImage,
  socialmedia_PosterImage,
  calendar_PosterImage,
  folder,
  dashboard,
  taskboard,
  calendar,
  reports,
  invoicing,
  team,
  storage,
  settings,
  clients,
  broadcast,
  logout,
  man,
  profile,
  date,
  shuffle,
  user,
  pdf,
  doc,
  excel,
  csv,
  text,
  ppt,
  zip,
  video,
  audio,
  recurring,
  formIcon,
  singleLine,
  multiLine,
  email,
  name,
  fileUpload,
  imageUpload,
  termsAndConditions,
  currency,
  signature,
  dropDown,
  decisionBox,
  mobileNumber,
  numbers,
  fieldDate,
  checkBox,
  address,
  file,
  atom_logo_no_background,
  serviceopg1,
  vider_logo_white,

};
